<template>
  <div class="collapse" id="collapseExample">
    <v-card>
      <v-card-title primary-title>
        Datos Personales del Interesado...
        <v-spacer></v-spacer>
        <v-btn data-toggle="collapse" data-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample" color="warning" rounded outlined>
          Cerrar Formulario <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-subtitle class="pb-0">
        <b>NOTA:.</b> Utilice este formulario solamente si no encontró al estudiante en el cuadro de busqueda. (Sino en vano va a llenar este formulario) El
        estudiante se crea o registra una sola ves, si el estudiante ya fue registrado en esta sede o en otra sede, no es necesario volverlo a inscribir, se
        puede reutilizar los mismos datos personales del estudiante para futuras inscripciones.
      </v-card-subtitle>

      <v-card-text>
        <v-form ref="formPersona" v-model="valid" lazy-validation @submit.prevent="validate">
          <v-container>
            <h3>I. Datos Personales (Estudiante)</h3>
            <v-row>
              <!-- row one -->
              <v-col cols="12" md="4" sm="6">
                <v-text-field
                  v-model="persona.numero_documento"
                  :counter="20"
                  :error-messages="numDocRules"
                  label="Rude / C.I."
                  hint="Documento de Identidad Carnet sin Extension"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="4" sm="6">
                <v-select clearable v-model="persona.departamento_id" :items="departamentos" item-value="id" xitem-text="nombre" label="Extension de Carnet"></v-select>
              </v-col>
              <v-col cols="12" md="4" sm="12">
                <v-row>
                  <v-select
                    clearable
                    v-model="persona.ciudad_id"
                    :items="ciudades"
                    :rules="fieldRules"
                    item-value="id"
                    item-text="nombre"
                    label="Ciudad De Residencia"
                  ></v-select>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn @click="showDialogAddCiudad" elevation="24" v-bind="attrs" v-on="on" outlined tile color="primary darken-2" class="ma-2" icon>
                        <v-icon dark> mdi-city </v-icon>
                      </v-btn>
                    </template>
                    Añadir Nueva Ciudad
                  </v-tooltip>
                </v-row>
              </v-col>
              <!-- row two -->
              <v-col cols="12" md="4">
                <v-text-field v-model="persona.nombres" :counter="30" label="Nombres" :rules="[(v) => !!v || 'Se requiere un nombre']"></v-text-field>
              </v-col>
              <v-col cols="12" md="4" sm="6">
                <v-text-field v-model="persona.primer_apellido" :counter="25" label="Primer Apellido" :rules="[(v) => !!v || 'Se requiere un apellido']">
                </v-text-field>
              </v-col>
              <v-col cols="12" md="4" sm="6">
                <v-text-field v-model="persona.segundo_apellido" :counter="25" label="Segundo Apellido"></v-text-field>
              </v-col>
              <v-col cols="12" v-if="persona.nombres && persona.primer_apellido">
                <i>
                  NOTA: El certificado emitido será a nombre de:
                  <b> {{ persona.nombres }} {{ persona.primer_apellido }} {{ persona.segundo_apellido }} </b>
                </i>
              </v-col>
              <!-- row three -->
              <v-col cols="12" md="4" sm="6">
                <p>Sexo</p>
                <v-radio-group v-model="persona.sexo" row>
                  <v-radio label="Femenino" value="F"></v-radio> <v-radio label="Masculino" value="M"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="12" md="4" sm="6">
                <v-menu ref="menu_persona" v-model="menu_persona" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :rules="fieldRules"
                      v-model="persona.fecha_nacimiento"
                      label="Fecha de Nacimiento"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    >
                    </v-text-field>
                  </template>
                  <v-date-picker
                    ref="date_picker_p"
                    v-model="persona.fecha_nacimiento"
                    :max="new Date().toISOString().substr(0, 10)"
                    min="1950-01-01"
                    year-icon="mdi-calendar-blank"
                    prev-icon="mdi-skip-previous"
                    next-icon="mdi-skip-next"
                    @change="saveDatePersona"
                  >
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="4" sm="12">
                <v-text-field type="number" v-model="edad" label="Edad" readonly></v-text-field>
              </v-col>
              <v-col cols="12" md="4" sm="6">
                <v-row>
                  <v-combobox v-model="persona.institucion_id" :items="unidadesEducativas" item-text="nombre" label="Unidad Educativa / Colegio"> </v-combobox>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn @click="showDialogAddUE" elevation="24" v-bind="attrs" v-on="on" outlined tile color="primary darken-2" class="ma-2" icon>
                        <v-icon dark> mdi-bank-plus </v-icon>
                      </v-btn>
                    </template>
                    Añadir Nueva Unidad Educativa
                  </v-tooltip>
                </v-row>
              </v-col>
              <v-col cols="12" md="4" sm="6">
                <v-row>
                  <v-combobox v-model="persona.nivel_academico_id" :items="nivelesAcademicos" item-text="nombre" label="Nivel Academico"></v-combobox>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn @click="showDialogAddNivelA" elevation="24" v-bind="attrs" v-on="on" outlined tile color="primary darken-2" class="ma-2" icon>
                        <v-icon dark> mdi-home-plus </v-icon>
                      </v-btn>
                    </template>
                    Añadir Nivel Academico
                  </v-tooltip>
                </v-row>
              </v-col>
              <v-col cols="12" md="4" sm="12">
                <v-text-field v-model="persona.domicilio" :counter="100" label="Direccion / Domicilio" hint="Lugar de Residencia Actual"> </v-text-field>
              </v-col>
            </v-row>
            <!-- row-four -->
            <h3>II. Datos Adicionales del Apoderado</h3>
            <v-row>
              <!-- =============================== -->
              <!-- row one -->
              <v-col cols="12" md="4" sm="6">
                <v-text-field
                  v-model="apoderado.numero_documento"
                  :counter="20"
                  :error-messages="numDocRules"
                  label="C.I."
                  hint="C.I. del apoderado, sin extension"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="4" sm="6">
                <v-select v-model="apoderado.departamento_id" :items="departamentos" item-value="id" item-text="nombre" label="Extension de Carnet"></v-select>
              </v-col>
              <v-col cols="12" md="4">
                <v-select v-model="apoderado.ciudad_id" :items="ciudades" item-value="id" item-text="nombre" label="Ciudad De Residencia del apoderado"></v-select>
              </v-col>
              <!-- row two -->
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="apoderado.nombres"
                  :counter="30"
                  label="Nombre de Apoderado"
                  :rules="[(v) => !!v || 'Se requiere un nombre']"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4" sm="6">
                <v-text-field v-model="apoderado.primer_apellido" :counter="30" label="Primer Apellido" :rules="[(v) => !!v || 'Se requiere un apellido']">
                </v-text-field>
              </v-col>
              <v-col cols="12" md="4" sm="6">
                <v-text-field v-model="apoderado.segundo_apellido" :counter="25" label="Segundo Apellido"></v-text-field>
              </v-col>
              <!-- row three -->
              <v-col cols="12" md="4" sm="6">
                <p>Sexo</p>
                <v-radio-group v-model="apoderado.sexo" row>
                  <v-radio label="Femenino" value="F"></v-radio> <v-radio label="Masculino" value="M"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="12" md="4" sm="6">
                <p>Estado Civil</p>
                <v-radio-group v-model="apoderado.estado_civil" row>
                  <v-radio label="Casado" value="C"></v-radio> <v-radio label="Soltero" value="S"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="12" md="4" sm="6">
                <v-menu ref="menu_apoderado" v-model="menu_apoderado" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :rules="fieldRules"
                      v-model="apoderado.fecha_nacimiento"
                      label="Fecha de Nacimiento"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    >
                    </v-text-field>
                  </template>
                  <v-date-picker
                    ref="date_picker_a"
                    v-model="apoderado.fecha_nacimiento"
                    :max="new Date().toISOString().substr(0, 10)"
                    min="1950-01-01"
                    year-icon="mdi-calendar-blank"
                    prev-icon="mdi-skip-previous"
                    next-icon="mdi-skip-next"
                    @change="saveDateApoderado"
                  >
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="4" sm="5">
                <v-text-field
                  v-model="apoderado.email"
                  label="Correo Electronico"
                  :counter="100"
                  :rules="emailRules"
                  hint="A Este Correo Electronico se enviará el Certificado y todas las notificaciones"
                  persistent-hint
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4" sm="6">
                <v-text-field
                  type="text"
                  v-model.trim="apoderado.telefono1"
                  :rules="fieldRules"
                  :counter="20"
                  label="Telefono Movil"
                  hint="Preferencia (WhatsApp), a este numero se enviará las notificaciones"
                  persistent-hint
                >
                </v-text-field>
              </v-col>

              <!-- =============================== -->
              <!-- row five -->
              <v-col cols="12" md="4" sm="6">
                <v-text-field
                  :counter="20"
                  type="text"
                  v-model.trim="apoderado.telefono2"
                  label="Telefono Adicional"
                  hint="Preferentemente de Familiar cercano (WhatsApp)"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4" sm="6">
                <v-text-field v-model="apoderado.datos_laborales" label="Lugar de Trabajo" hint="Del Apoderado"></v-text-field>
              </v-col>
              <v-col cols="12" md="4" sm="12">
                <v-text-field v-model="apoderado.domicilio" :counter="100" label="Direccion / Domicilio" hint="Residencia Actual del Apoderado"> </v-text-field>
              </v-col>

              <!-- row six -->
            </v-row>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <h3 v-bind="attrs" v-on="on" color="primary">III. Datos De Acceso al Sistema</h3>
              </template>
              Estos Datos se Generan Automaticamente del Nombre y Rude/CI.
            </v-tooltip>
            <v-row>
              <v-col cols="12" md="4" sm="6">
                <v-text-field v-model="persona.usuario_moodle" label="Usuario Moodle"></v-text-field>
              </v-col>
              <v-col cols="12" md="4" sm="6">
                <v-text-field v-model="persona.clave_moodle" label="Clave Moodle"></v-text-field>
              </v-col>
              <!-- row seven -->
            </v-row>
            <p class="text-center"> {{msgerr}} </p>
            <v-row>
              <v-btn type="submit" :disabled="!valid" color="success" class="mr-4">
                <v-icon class="ma-2">mdi-content-save-all</v-icon> Registrar Estudiante
              </v-btn>
              <v-btn color="warning" class="mr-4" @click="resetForm"> Limpiar Formulario </v-btn>
            </v-row>
          </v-container>
        </v-form>
        <div>
          <v-btn data-toggle="collapse" data-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample" color="warning" rounded outlined>
            Cerrar Formulario <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </v-card-text>
      <v-layout row justify-center>
        <v-dialog v-model="dialogCreateCiudad" width="90%">
          <v-form ref="formCIUDAD" lazy-validation @submit.prevent="registerCiudad">
            <v-card>
              <v-card-title>
                <span class="headline">DATOS DE LA CIUDAD</span>
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12">
                    <v-combobox v-model="ciudad.departamento" :rules="fieldRules" :items="departamentos" item-text="nombre" label="Departamento"> </v-combobox>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field v-model="ciudad.nombre" :rules="fieldRules" :counter="100" label="Nombre Ciudad"> </v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn tile outlined color="primary" @click="closeDialogAddCiudad">Cancelar</v-btn>
                <v-btn type="submit" tile outlined color="green darken-1">Guardar Datos</v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>

        <v-dialog v-model="dialogCreateUE" width="90%">
          <v-form ref="formUE" lazy-validation @submit.prevent="registerInstitucion">
            <v-card>
              <v-card-title>
                <span class="headline">DATOS DEL UNIDAD EDUCATIVA</span>
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12">
                    <v-text-field v-model="unidad_e.nombre" :rules="fieldRules" :counter="100" label="Nombre UE" hint="Nombre de la Unidad Educativa">
                    </v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field v-model="unidad_e.abreviatura" :counter="30" label="Abreviatura" hint="Nombre Corto"></v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn tile outlined color="primary" @click="closeDialogAddUE">Cancelar</v-btn>
                <v-btn type="submit" tile outlined color="green darken-1">Guardar Datos</v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>
        <v-dialog v-model="dialogCreateNivelA" width="90%">
          <v-form ref="formNA" lazy-validation @submit.prevent="registerNivelAcad">
            <v-card>
              <v-card-title>
                <span class="headline">Datos Del Nivel Academico</span>
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12">
                    <v-text-field v-model="nivel_academico.nombre" :rules="fieldRules" :counter="100" label="Curso" hint="Solo texto, Ejemplo: Quinto basico">
                    </v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field v-model="nivel_academico.nivel" :counter="30" label="Nivel" hint="Primaria o Secundaria"></v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn tile outlined color="primary" @click="closeDialogAddNivelA">Cancelar</v-btn>
                <v-btn type="submit" tile outlined color="green darken-1">Guardar Datos</v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>
      </v-layout>
    </v-card>
    <Alertas />
  </div>
</template>
<script>
import Alertas from '@/components/AAlertas.vue';
import gql from 'graphql-tag';
import { getCleanedString } from '@/components/Utils.js';
import { mapState } from 'vuex';

import { validationMixin } from 'vuelidate';
import xaxios from '@/xaxios';
// import { required } from 'vuelidate/lib/validators';

export default {
  mixins: [validationMixin],
  props: { inscripcion: { type: Object, required: true } },
  components: { Alertas },
  data() {
    return {
      // regexp.MustCompile(`^\+[0-9]?()[0-9]{0,2}(\s|\S)(\d[0-9]{4,10})$`)
      dialogCreateCiudad: false,
      dialogCreateUE: false,
      dialogCreateNivelA: false,
      nivel_academico: { nombre: null, nivel: 'Primaria' },
      ciudad: { nombre: null, departamento: null },
      menu_name: process.env.VUE_APP_NAME_MENU,
      api_rest: process.env.VUE_APP_API_REST,
      // api_rest_moodle: process.env.UE_APP_API_REST_MOODLE,
      fieldRules: [(v) => !!v || 'Campo Obligatorio'],
      emailRules: [(v) => !!v || 'E-mail es Requerido', (v) => /.+@.+\..+/.test(v) || 'E-mail no válido'],
      menu_persona: false,
      menu_apoderado: false,
      valid: true,
      departamentos: [],
      unidadesEducativas: [],
      nivelesAcademicos: [],
      grados: [],
      ciudades: [],
      edad: 0,
      unidad_e: { nombre: null, abreviatura: null },
      persona_defaul_value: null,
      apoderado_defaul_value: null,
      // =====================
      persona: {
        numero_documento: null,
        nombres: null,
        primer_apellido: null,
        segundo_apellido: null, //puede ser null
        domicilio: null, //puede ser null
        telefono1: null, //puede ser null
        telefono2: null, //puede ser null
        email: null,
        sexo: 'M',
        fecha_nacimiento: null, //puede ser null
        estado_civil: 'S', //puede ser null
        usuario_moodle: null, //puede ser null
        clave_moodle: null, //puede ser null
        datos_laborales: null, //puede ser null
        tipo: 'E',
        ciudad_id: null, //puede ser null
        institucion_id: null, //puede ser null
        empresa_id: null, //puede ser null
        diestro: true,
        pais_id: null, //puede ser null
        departamento_id: null, //puede ser null
        contacto: '', //puede ser null
        student_id: null, //puede ser null
        profesiones: null, //puede ser null
        grados: null, //puede ser null
        nivel_academico_id: null, //puede ser null
      },
      apoderado: {
        numero_documento: null,
        nombres: null,
        primer_apellido: null,
        segundo_apellido: null, //puede ser null
        domicilio: null, //puede ser null
        telefono1: null, //puede ser null
        telefono2: null, //puede ser null
        email: null,
        sexo: 'M',
        fecha_nacimiento: null, //puede ser null
        estado_civil: 'S', //puede ser null
        usuario_moodle: null, //puede ser null
        clave_moodle: null, //puede ser null
        datos_laborales: null, //puede ser null
        tipo: 'E',
        ciudad_id: null, //puede ser null
        institucion_id: null, //puede ser null
        empresa_id: null, //puede ser null
        diestro: true,
        pais_id: null, //puede ser null
        departamento_id: null, //puede ser null
        contacto: null, //puede ser null
        student_id: null, //puede ser null
        profesiones: null, //puede ser null
        grados: null, //puede ser null
        nivel_academico_id: null, //puede ser null
      },

      datamsg: '',
      plataforma: {},
      msgerr: '',
    };
  },
  validations: {
    persona: {
      numero_documento: {
        isUnique(numero_documento) {
          if (numero_documento === null) return false;
          if (numero_documento && numero_documento.length <= 3) return false;
          return new Promise((resolve) => resolve(this.verifyIfExistsNumDoc(numero_documento)));
        },
      },
    },
  },
  computed: {
    ...mapState({ programa: (state) => state.programa.value }),
    numDocRules() {
      const errors = [];
      this.$v.persona.numero_documento.isUnique && errors.push('Este Número de Documento ya Existe');
      // !this.$v.persona.numero_documento.required && errors.push('Este campo es Obligatorio.');
      return errors;
    },
  },
  watch: {
    'persona.nombres': function () {
      this.crearLogin();
    },
    'persona.primer_apellido': function () {
      this.crearLogin();
    },
    'persona.segundo_apellido': function () {
      this.crearLogin();
    },
    'persona.numero_documento': function () {
      this.crearClave();
    },
    'persona.departamento_id': function () {
      this.crearClave();
    },
    'apoderado.email': function (email) {
      this.persona.email = email;
    },
    'apoderado.telefono1': function (telefono) {
      this.persona.telefono1 = telefono;
    },
    'apoderado.telefono2': function (telefono2) {
      this.persona.telefono2 = telefono2;
    },
    // ==============
    menu_persona(val) {
      val && setTimeout(() => (this.$refs.date_picker_p.activePicker = 'YEAR'));
    },
    menu_apoderado(val) {
      val && setTimeout(() => (this.$refs.date_picker_a.activePicker = 'YEAR'));
    },
  },
  methods: {
    // ==========
    validate() {
      this.$refs.formPersona.validate() ? this.enviarDatos() : null;
    },
    // register the new unidad Educativa
    registerCiudad() {
      if (this.$refs.formCIUDAD.validate()) {
        const sql = gql`mutation{ createCiudad(input:{nombre: "${this.ciudad.nombre}", iddepartamento:${this.ciudad.departamento.id}}){ ok errors{message}} }`;
        window.console.log('mutation', sql);
        this.$apollo
          .mutate({ mutation: sql })
          .then(({ data: { createCiudad } }) => {
            if (createCiudad.ok) {
              this.$root.$notify.show('Ciudad Añadido', { color: 'success' });
              this.getCiudades();
            } else {
              this.$root.$notify.show('No se pudo añadir la Ciudad', { color: 'red' });
            }
            this.closeDialogAddCiudad();
          })
          .catch(() => this.$root.$notify.show('Ciudad no creada', { color: 'red' }));
      }
    },
    registerInstitucion() {
      if (this.$refs.formUE.validate()) {
        const sql = gql`mutation{ createInstitucion(input:{nombre: "${this.unidad_e.nombre}", abreviatura:"${this.unidad_e.abreviatura}", tipo:"E", convenio:false}){ ok errors{message}} }`;
        this.$apollo
          .mutate({ mutation: sql })
          .then(({ data: { createInstitucion } }) => {
            if (createInstitucion.ok) {
              this.$root.$notify.show('Unidad Educativa Añadido', { color: 'success' });
              this.getInstituciones();
            } else {
              this.$root.$notify.show('No se pudo añadir la Unidad Educativa', { color: 'red' });
            }
            this.closeDialogAddUE();
          })
          .catch(() => this.$root.$notify.show('Unidad Educativa no creada', { color: 'red' }));
      }
    },
    registerNivelAcad() {
      if (this.$refs.formNA.validate()) {
        xaxios
          .post(`${this.api_rest}/esam/persona/nivel/academico`, this.nivel_academico)
          .then(() => {
            this.$root.$notify.show(`Nivel Academico Añadido`, { color: 'success' });
            this.closeDialogAddNivelA();
            this.getGetNivelesAcademicos();
          })
          .catch(() => {});
      }
    },
    resetForm() {
      this.$refs.form.reset();
    },
    saveDatePersona(date) {
      var diff_ms = Date.now() - new Date(date).getTime();
      this.edad = Math.abs(new Date(diff_ms).getUTCFullYear() - 1970);
      this.$refs.menu_persona.save(date);
    },
    saveDateApoderado(date) {
      this.$refs.menu_apoderado.save(date);
    },

    showDialogAddUE() {
      this.dialogCreateUE = true;
    },
    showDialogAddCiudad() {
      this.dialogCreateCiudad = true;
    },
    showDialogAddNivelA() {
      this.dialogCreateNivelA = true;
    },
    closeDialogAddUE() {
      this.unidad_e = { nombre: null, abreviatura: null };
      this.dialogCreateUE = false;
    },
    closeDialogAddCiudad() {
      this.ciudad = { nombre: null, departamento: null };
      this.dialogCreateCiudad = false;
    },
    closeDialogAddNivelA() {
      this.nivel_academico = { nombre: null, nivel: 'Primaria' };
      this.dialogCreateNivelA = false;
    },

    async verifyIfExistsNumDoc(num_doc) {
      const sql = gql`query{ getEstudiantesByDoc(num_doc:"${num_doc}"){id,num_doc,nombres,pri_apellido,seg_apellido } }`;
      let result = false;
      result = await this.$apollo.query({ query: sql }).then(({ data: { getEstudiantesByDoc } }) => {
        if (getEstudiantesByDoc && getEstudiantesByDoc.length > 0) return true;
      });
      return result;
    },

    getDepartamentos() {
      const sql = gql`
        query {
          getDepartamentos {
            id
            nombre
            extension
          }
        }
      `;
      this.$apollo
        .query({ query: sql })
        .then(({ data: { getDepartamentos } }) => {getDepartamentos.map(x=>{x.text = x.nombre});this.departamentos = getDepartamentos})
        .catch((error) => window.console.error(error));
    },
    getCiudades() {
      const sql = gql`
        query {
          getCiudades {
            id
            nombre
          }
        }
      `;
      this.$apollo
        .query({ query: sql })
        .then(({ data: { getCiudades } }) => (this.ciudades = getCiudades))
        .catch((error) => window.console.error(error));
    },
    async getInstituciones() {
      const sql = gql`
        query {
          getInstituciones(estado: true) {
            id
            nombre
            tipo
            convenio
            abreviatura
          }
        }
      `;
      await this.$apollo
        .query({ query: sql })
        .then(({ data: { getInstituciones } }) => (this.unidadesEducativas = getInstituciones.filter((item) => item.tipo == 'E')))
        .catch((error) => window.console.error(error));
    },
    getGrados() {
      const sql = gql`
        query {
          getGrados {
            id
            nombre
            nivel
          }
        }
      `;
      this.$apollo
        .query({ query: sql })
        .then(({ data: { getGrados } }) => (this.grados = getGrados))
        .catch(() => this.$root.$notify.show('Nose Cargaron los Grados', { color: 'red' }));
    },
    getGetNivelesAcademicos() {
      xaxios
        .get(`${this.api_rest}/esam/persona/nivel/academico`)
        .then(({ data }) => (this.nivelesAcademicos = data))
        .catch(() => this.$root.$notify.show('Nose Cargaron los Niveles Academicos', { color: 'red' }));
    },
    addCiudad() {
      const sql = gql`
        mutation {
          createCiudad(input: {}) {
            ok
            errors {
              message
            }
          }
        }
      `;
      this.$apollo
        .mutate({ mutation: sql })
        .then(({ data: { createCiudad } }) => {
          window.console.log(createCiudad);
          this.getCiudades();
        })
        .catch((error) => window.console.error(error));
    },
    // ==========
    crearLogin() {
      let username = '';
      let nombres = this.persona.nombres;
      let primer_apellido = this.persona.primer_apellido;
      let segundo_apellido = this.persona.segundo_apellido;
      nombres && nombres.length > 0 ? (username = nombres.substring(0, 1)) : null;
      primer_apellido ? (username = username + primer_apellido.replace(/\s+/g, '')) : null;
      segundo_apellido ? (username = username + segundo_apellido.replace(/\s+/g, '')) : null;
      this.persona.usuario_moodle = username ? getCleanedString(username) : null;
    },
    crearClave() {
      let password = '';
      let num_doc = this.persona.numero_documento;
      let dep = this.departamentos.find(x=>x.id==this.persona.departamento_id);
      num_doc && num_doc.length > 0 ? (password = this.persona.numero_documento) : null;
      dep ? (password = password + dep.extension) : null;
      this.persona.clave_moodle = password;

      let d = this.simpleValues(this.persona);
      let e = this.simpleValues(this.apoderado);
      window.console.log(JSON.stringify(d,null,4));
      window.console.log(JSON.stringify(e,null,4));
    },

    simpleValues(ob) {
      let obj = window.Object.assign({},ob);
      obj.numero_documento = obj.numero_documento ? obj.numero_documento : this.autoGenerarNumDoc();
      obj.empresa_id != null ? (obj.empresa_id = obj.empresa_id.id) : delete obj.empresa_id;
      //obj.departamento_id != null ? (obj.departamento_id = obj.departamento_id.id) : delete obj.departamento_id;
      //obj.ciudad_id != null ? (obj.ciudad_id = obj.ciudad_id.id) : delete obj.ciudad_id;
      obj.institucion_id != null ? (obj.institucion_id = obj.institucion_id.id) : delete obj.institucion_id;
      obj.nivel_academico_id != null ? (obj.nivel_academico_id = obj.nivel_academico_id.id) : delete obj.nivel_academico_id;
      //if( obj.telefono1 && !obj.telefono1.startsWith('+') ) obj.telefono1 = '+'+obj.telefono1; 
      for (const key in obj) {
        /* if (obj.hasOwnProperty(key) && obj[key] === null) {
          delete obj[key];
        } */
        if (obj.hasOwnProperty(key) && !obj[key]) {
          delete obj[key];
        }
      }
      return obj;
    },
    autoGenerarNumDoc() {
      if( !this.persona.nombres ) this.persona.nombres = '';
      if( !this.persona.primer_apellido ) this.persona.primer_apellido = '';
      if( !this.persona.segundo_apellido ) this.persona.segundo_apellido = '';
      if( !this.persona.fecha_nacimiento ) this.persona.fecha_nacimiento = '';
      
      let name = this.persona.nombres
        .split(' ')
        .map((a) => (a ? a.slice(0, 2) : null))
        .join('');
      let pri_apellido = this.persona.primer_apellido
        .split(' ')
        .map((a) => (a ? a.slice(0, 2) : null))
        .join('');
      let seg_apellido = this.persona.segundo_apellido
        ? this.persona.segundo_apellido
            .split(' ')
            .map((a) => (a ? a.slice(0, 2) : null))
            .join('')
        : '';
      let num_doc = this.persona.fecha_nacimiento.split('-').reverse().join('');
      // window.console.log('autoGenerarNumDoc', `${name}${pri_apellido}${seg_apellido}${num_doc}`);
      return `${+num_doc}${name}${pri_apellido}${seg_apellido}`;
    },

    parseLabel2(persona) {
      let seg_apellido = persona.primer_apellido ? persona.primer_apellido : '';
      let num_doc = persona.numero_documento ? `-- ${persona.numero_documento}` : '';
      return `${persona.nombres} ${persona.primer_apellido} ${seg_apellido} ${num_doc}`;
    },

    enviarDatos() {
      // const url2 = `${this.api_rest}/esam/persona/id/${id}`; // obtiene los datos de la persona
      const url = `${this.api_rest}/esam/persona`;
      this.msgerr = '';
      // let data_format = { persona: this.simpleValues(this.persona), apoderado: this.simpleValues(this.apoderado) };
      // window.console.log(JSON.stringify(data_format), 'this.persona', url);
      xaxios
        .post(url, { persona: this.simpleValues(this.persona), apoderado: this.simpleValues(this.apoderado) })
        .then(({ data }) => {
          // este inde se debe asigar al valor de retorno y cerllar el dialog, o el collapse
          if (data.persona_id) {
            // window.console.log('success, create, persona and poderado', data, data.persona_id);
            this.inscripcion.idestudiante = { id: data.persona_id, nombre: this.parseLabel2(this.persona) };
            setTimeout(function () {
              window.$('#collapseExample').collapse('hide');
              window.scrollTop({ top: 0, left: 0, behavior: 'smooth' });
            }, 1000);
            this.persona = this.persona_defaul_value;
            this.apoderado = this.apoderado_defaul_value;
            this.$root.$notify.show('EXISTO: Inscripcion Creada', { color: 'success' });

            //this.$emit('onnewregistro', this.persona.numero_documento);

          } else {
            this.$root.$notify.show('ERROR: Inscripcion no creada', { color: 'red' });
          }
        }) 
        .catch((e) => {
          //window.console.log('error', e, JSON.stringify(e));
          try{
            this.msgerr = e.response.data.error;
          }catch(_){
            this.msgerr = '';
          }
          this.$root.$notify.show('ERROR: No se creo el registro', { color: 'red' });
        });
    },
  },
  mounted() {
    this.getDepartamentos();
    this.getCiudades();
    this.getInstituciones();
    this.getGetNivelesAcademicos();

    /*this.persona = {
      numero_documento: '1234574122',
      nombres: 'jose',
      primer_apellido: 'miguel',
      domicilio: 'domiciolio',
      telefono1: '89456125',
      email: 'correo@gmail.com',
      sexo: 'M',
      fecha_nacimiento: '2021-02-03',
      estado_civil: 'S',
      usuario_moodle: 'jmiguel',
      clave_moodle: '1234574122',
      tipo: 'S',
      institucion_id: 103,
      diestro: true,
      contacto: '',
      nivel_academico_id: 1,
    };
    this.apoderado = {
      numero_documento: '741258745',
      nombres: 'diego',
      primer_apellido: 'saldias',
      segundo_apellido: 'torrez',
      domicilio: 'san lucas',
      telefono1: '89456125',
      email: 'correo@gmail.com',
      sexo: 'M',
      fecha_nacimiento: '2020-05-06',
      estado_civil: 'C',
      datos_laborales: 'esam',
      tipo: 'S',
      ciudad_id: 4,
      diestro: true,
      departamento_id: 1,
    };

    this.persona_defaul_value = this.persona;
    this.apoderado_defaul_value = this.apoderado;*/
  },
};
// ============observaciones dudas==========
// como se esta uniendo persona con  apoderado?
// cada que se manda un registro de apoderado crea un nuevo registro no?
// si un padre o apoderado inscribe a 2 o mas de sus hijos al sistema, se crearon 2 o mas registros del apoderado?
</script>
